import { useEffect, useState } from "react";

// Component and CSS map
const componentMap = {
    "Call_Us_Temp": {
        component: () => import("./CallUsWidget"),
        cssFile: `${process.env.PUBLIC_URL}/click-to-call/temp-css/CallUsWidget.css`, 
    },
    "Sale_Temp": {
        component: () => import("./SaleWidget"),
        cssFile: `${process.env.PUBLIC_URL}/click-to-call/temp-css/SaleWidget.css`, 
    },
    "Consultation_Temp": {
        component: () => import("./ConsultationWidget"),
        cssFile: `${process.env.PUBLIC_URL}/click-to-call/temp-css/ConsultationWidget.css`, 
    },
    "Support_Temp": {
        component: () => import("./SupportWidget"),
        cssFile: `${process.env.PUBLIC_URL}/click-to-call/temp-css/SupportWidget.css`, 
    },
    "Booking_Temp": {
        component: () => import("./BookingWidget"),
        cssFile: `${process.env.PUBLIC_URL}/click-to-call/temp-css/BookingWidget.css`, 
    },
    "Floating_Call_Button_Temp": {
        component: () => import("./FloatingCallButtonWidget"),
        cssFile: `${process.env.PUBLIC_URL}/click-to-call/temp-css/FloatingCallButtonWidget.css`, 
    },
}; 

const DynamicTemplate = ({ selectedTemplate, isTemplateId, widgetId, selectedLayout, clickToCallTabData }) => {
    const [TemplateComponent, setTemplateComponent] = useState(null);

    useEffect(() => {
        const loadTemplate = async () => {
            const template = componentMap[selectedTemplate];
            if (!template) {
                setTemplateComponent(null);
                return;
            }

            // Remove all previously injected dynamic CSS
            const oldLinks = document.querySelectorAll('link[data-dynamic-css]');
            oldLinks.forEach(link => link.remove());

            // Inject new CSS
            if (template.cssFile) {
                const link = document.createElement("link");
                link.rel = "stylesheet";
                link.href = template.cssFile;
                if (widgetId) {
                    link.setAttribute("click-to-call-data-dynamic-css", selectedTemplate);
                } else {
                    link.setAttribute("data-dynamic-css", selectedTemplate);
                }
                document.head.appendChild(link);
            }

            // Load component
            const componentModule = await template.component();
            setTemplateComponent(() => componentModule.default);
        };

        loadTemplate();
    }, [selectedTemplate,widgetId]);

    if (!TemplateComponent)
        return (
            <div className="loader-container">
                <div className="spinner"></div>
                <p>Loading please wait...</p>
            </div>
        );

    return (
        <TemplateComponent selectedTemplate={selectedTemplate} selectedLayout={selectedLayout} isTemplateId={isTemplateId} widgetId={widgetId} clickToCallTabData={clickToCallTabData}
        /> 
    );
};

export default DynamicTemplate;
